window.addEventListener('DOMContentLoaded', () => {
	var slider = new KeenSlider(
		'.testimonials .keen-slider',
		{
			loop: true,
			breakpoints: {
				'(min-width: 768px)': {
					slides: {
						perView: 1.5,
						spacing: 24,
					},
				},
				'(min-width: 992px)': {
					slides: {
						perView: 2,
						spacing: 32,
					},
				},
				'(min-width: 1200px)': {
					slides: {
						perView: 2.5,
						spacing: 40,
					},
				},
			},
			slides: {
				perView: 1,
				spacing: 16,
			},
			defaultAnimation: {
				duration: 800,
			},
		},
		[
			slider => {
				let timeout
				let mouseOver = false
				function clearNextTimeout() {
					clearTimeout(timeout)
				}
				function nextTimeout() {
					clearTimeout(timeout)
					if (mouseOver) return
					timeout = setTimeout(() => {
						slider.next()
					}, 4000)
				}
				slider.on('created', () => {
					slider.container.addEventListener('mouseover', () => {
						mouseOver = true
						clearNextTimeout()
					})
					slider.container.addEventListener('mouseout', () => {
						mouseOver = false
						nextTimeout()
					})
					nextTimeout()
				})
				slider.on('dragStarted', clearNextTimeout)
				slider.on('animationEnded', nextTimeout)
				slider.on('updated', nextTimeout)

				// This is a fix for the slider not looping properly when it reaches a certain number of loops
				slider.on('animationEnded', slider => {
					const { rel, progress } = slider.track.details
					if (rel === 0 && progress !== 0) {
						slider.moveToIdx(0, true, { duration: 0 })
					}
				})
			},
		]
	)
})
